import { render, staticRenderFns } from "./FanKuiDan.vue?vue&type=template&id=6031dda4&scoped=true&"
import script from "./FanKuiDan.vue?vue&type=script&lang=js&"
export * from "./FanKuiDan.vue?vue&type=script&lang=js&"
import style0 from "./FanKuiDan.vue?vue&type=style&index=0&id=6031dda4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6031dda4",
  null
  
)

export default component.exports